var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 62,
    viewBox: "0 0 342 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114 57.027H105V4L105.5 4.48649L137.5 36.1081L137 4H147V57.027L114 25.4054V57.027Z",
    fill: "#0B3F51",
    stroke: "#0B3F51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169 57H160V4H183.5C194.5 7.5 196 14 196 23C196 30.2 189.667 34.6667 186.5 36L187 36.5L198 57H197H187L173.5 29.5H174H182L183.5 28.5C184.667 27.3333 187 23.9 187 19.5C187 15.1 182.667 13 180.5 12.5H169V57Z",
    fill: "#0B3F51",
    stroke: "#0B3F51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5 57H209H208V4H218V48.5H240L239.5 49.5L235.5 57Z",
    fill: "#0B3F51",
    stroke: "#0B3F51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M239.5 4H230L248.5 35L253 26.5L239.5 4Z",
    fill: "#0B3F51",
    stroke: "#0B3F51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M265.5 4.5L261 12H284L257.5 57H296V48.5H272.5L298.5 4.5H265.5Z",
    fill: "#0B3F51",
    stroke: "#0B3F51"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.5 56.5V4H341V12.5H318V25.5H339V26.5V34.5H318V48.5H341.5V56.5H308.5Z",
    fill: "#0B3F51",
    stroke: "#0B3F51"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29 53.1688C22.3193 51.6616 16.3918 55.6808 14.2632 57.8788C17.014 46.1979 29.1637 44.8477 34.8947 45.6327C38.4971 47.5167 49.1404 52.6977 56.5088 53.1688C62.9757 53.5822 69.7719 51.1277 73.2105 49.8717C71.2456 53.6397 67.807 57.4078 62.4035 59.7628C58.0807 61.6468 47.5029 61.0188 44.2281 60.2338C39.3158 57.8788 35.6807 54.676 29 53.1688Z",
    fill: "#51BAA2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.614 31.0316C15.1474 29.1476 5.09357 34.0146 1 36.6836C5.91228 23.4956 25.0702 17.3726 33.4211 21.6116C41.7719 25.8506 52.5789 30.0896 63.8772 31.0316C72.9158 31.7852 81.7251 28.2056 85 26.3216C83.5263 29.3046 78.5158 36.2127 70.2632 39.9807C62.0105 43.7487 51.1053 41.5507 46.6842 39.9807C41.7719 37.7827 30.0807 32.9156 22.614 31.0316Z",
    fill: "#51BAA2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4386 10.7785C25.3649 8.14086 16.2281 10.9356 14.2632 13.1336C15.2456 7.95257 28.0175 -3.35154 37.8421 2.77149C47.6667 8.89452 58.4737 10.7785 62.4035 9.83655C65.5474 9.08297 70.2632 7.32453 72.2281 6.53951C71.5731 8.10951 69.2807 11.8147 65.3509 14.0755C60.4386 16.9016 50.1228 18.7856 45.2105 16.4306C40.2982 14.0755 41.2807 14.0755 32.4386 10.7785Z",
    fill: "#51BAA2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29 53.1688C22.3193 51.6616 16.3918 55.6808 14.2632 57.8788C17.014 46.1979 29.1637 44.8477 34.8947 45.6327C38.4971 47.5167 49.1404 52.6977 56.5088 53.1688C62.9757 53.5822 69.7719 51.1277 73.2105 49.8717C71.2456 53.6397 67.807 57.4078 62.4035 59.7628C58.0807 61.6468 47.5029 61.0188 44.2281 60.2338C39.3158 57.8788 35.6807 54.676 29 53.1688Z",
    stroke: "#51BAA2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.614 31.0316C15.1474 29.1476 5.09357 34.0146 1 36.6836C5.91228 23.4956 25.0702 17.3726 33.4211 21.6116C41.7719 25.8506 52.5789 30.0896 63.8772 31.0316C72.9158 31.7852 81.7251 28.2056 85 26.3216C83.5263 29.3046 78.5158 36.2127 70.2632 39.9807C62.0105 43.7487 51.1053 41.5507 46.6842 39.9807C41.7719 37.7827 30.0807 32.9156 22.614 31.0316Z",
    stroke: "#51BAA2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4386 10.7785C25.3649 8.14086 16.2281 10.9356 14.2632 13.1336C15.2456 7.95257 28.0175 -3.35154 37.8421 2.77149C47.6667 8.89452 58.4737 10.7785 62.4035 9.83655C65.5474 9.08297 70.2632 7.32453 72.2281 6.53951C71.5731 8.10951 69.2807 11.8147 65.3509 14.0755C60.4386 16.9016 50.1228 18.7856 45.2105 16.4306C40.2982 14.0755 41.2807 14.0755 32.4386 10.7785Z",
    stroke: "#51BAA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.ddcaf890302fe814815a34fdeea281dc.svg";
export { ForwardRef as ReactComponent };